import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,_vm._b({attrs:{"outlined":""}},'v-card',_vm.$attrs,false),[_c(VCardText,[_c('div',{staticClass:"d-flex align-center flex-grow-1 grey--text"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }